export const userLoginMutation = (builder) => ({
  userLogin: builder.mutation({
    query: (credentials) => ({
      url: '/user_login',
      method: 'POST',
      body: credentials,
    }),
  }),
});